import React, { Component } from 'react';
import styled from 'styled-components';

import Notice from '../../../../web/components/Notice';
import LabelledTextInput from '../../../../web/components/LabelledTextInput';
import Checkbox from './components/Checkbox';

export default class Contact extends Component {
  componentDidMount() {
    /* eslint-disable-next-line */
		window.amplitude.getInstance().logEvent('Confirm Address Next button Click');
  }
  render() {
    const {
      financialAccountDetails,
      financialAccountDetails2,
    } = this.props.fields;

    return (
      <form style={{ backgroundColor: 'none', width: 965 }}>
        <div style={{ width: 965, margin: 25, paddingTop: 25, color: '#505d68' }}>
          Please enter your store’s financial account details…
        </div>
        <div style={{ width: 965, margin: 25, paddingTop: 0, color: '#505d68' }}>
          This allows blueshyft to batch pay you and collect funds deposited by customers on behalf of our payment providers.
        </div>
        <InputContainer>
          {financialAccountDetails2.map((field, key) => (
            <Column key={key}>
              <LabelledTextInput
                key={key}
                placeHolder={field.placeHolder}
                name={field.name}
                type="text"
                value={this.props.data[field.name]}
                onChange={this.props.onChange(field.name)}
              />
              { this.props.errors[field.name] ? (
                <div style={{ marginTop: 5 }}>
                  <Notice
                    color="red"
                    text={`Please enter a valid value`}
                    width="750"
                  />
                </div>
              ) : null }
            </Column>
          ))}
        </InputContainer>
        <div style={{ width: 965, margin: 25, paddingTop: 0, color: '#505d68' }}>
          “You”, request and authorise blueshyft Pty Ltd to arrange, through its own financial institution, a debit to your nominated account and any amount blueshyft Pty Ltd has deemed payable by “you”. 
        </div>
        <div style={{ width: 965, margin: 25, paddingTop: 0, color: '#505d68' }}>
          This debit or charge will be made through the Bulk Electronics Clearing System (BECS) from “your” account held at the financial institution you have nominated below and will be subject to the terms and conditions of the <a target="_blank" href="https://bsau-assets.s3-ap-southeast-2.amazonaws.com/docs/pdfs/blueshyft+Direct+Debit+Request+Service+Agreement.pdf" style={{ color: '#5d81ec' }}>Direct Debit Request Service Agreement</a>. 
        </div>
        <InputContainer>
          <Column style={{ width: '946px', display: 'flex', flexDirection: 'row' }}>
            <Checkbox type="checkbox" name="goodsCareCustodyConfirmation" label="test" checked={this.props.data.goodsCareCustodyConfirmation} onClick={this.props.onChange('goodsCareCustodyConfirmation')} style={{ width: '20px' }} />
            <span style={{ marginLeft: 2 }} />
            <span style={{ color: '#505d68', fontFamily: '"Karla", sans-serif;', fontSize: '16px', width: 965 }}>
              I have read, understood and agree to the terms and conditions governing the debit arrangements between you and blueshyft Pty Ltd as set out in this Request and in your <a target="_blank" href="https://bsau-assets.s3-ap-southeast-2.amazonaws.com/docs/pdfs/blueshyft+Direct+Debit+Request+Service+Agreement.pdf" style={{ color: '#5d81ec' }}>Direct Debit Request Service Agreement</a>.
            </span>
          </Column>
        </InputContainer>
        { this.props.errors.goodsCareCustodyConfirmation ? (
          <div style={{ marginTop: 5 }}>
            <Notice
              color="red"
              text="Please confirm that you understand and agree to the terms above."
              width="750"
            />
          </div>
        ) : null }
        <div style={{ width: 965, margin: 25, paddingTop: 0, color: '#505d68' }}>
          Has blueshyft Pty Ltd been named on your Goods Care Custody and Control insurance policy?
        </div>
        <div style={{ width: 965, margin: 25, paddingTop: 0, color: '#a4aeb7' }}>
          Feel free to leave this for now if you are unsure.
        </div>
        <InputContainer>
          <Column style={{ width: '946px' }}>
            <Checkbox
              type="checkbox"
              name="goodsCareCustodyYes"
              label="test"
              checked={this.props.data.goodsCareCustodyYes}
              onClick={this.props.onChange('goodsCareCustodyYes')}
              style={{ width: '20px' }}
            />
            <span style={{ color: '#505d68', fontFamily: '"Karla", sans-serif', fontSize: '16px', marginLeft: 2 }}>Yes</span>
            <span style={{ marginLeft: 20 }} />
            <Checkbox
              type="checkbox"
              name="goodsCareCustodyNotYet"
              label="test"
              checked={this.props.data.goodsCareCustodyNotYet}
              onClick={this.props.onChange('goodsCareCustodyNotYet')}
              style={{ width: '20px' }}
            />
            <span style={{ color: '#505d68', fontFamily: '"Karla", sans-serif', fontSize: '16px', marginLeft: 2 }}>Not yet</span>
          </Column>
          { this.props.errors.goodsCareCustodyConfirmation ? (
            <div style={{ marginTop: 5 }}>
              <Notice
                color="red"
                text="Please confirm that you understand and agree to the terms above."
                width="750"
              />
            </div>
          ) : null }
        </InputContainer>
        <div style={{ width: 965, margin: 25, paddingTop: 0, color: '#505d68' }}>
          Will you be signing the following contract as an individual or as a corporation?
        </div>
        <InputContainer>
          <Column style={{ width: '946px' }}>
            <Checkbox type="checkbox" name="individual" label="test" checked={this.props.data.individual} onClick={this.props.onChange('individual')} style={{ width: '20px' }} /><span style={{ color: '#505d68', fontFamily: '"Karla", sans-serif', fontSize: '16px', marginLeft: 2 }}>Individual</span>
            <span style={{ marginLeft: 20 }} />
            <Checkbox type="checkbox" name="corporation" label="test" checked={this.props.data.corporation} onClick={this.props.onChange('corporation')} style={{ width: '20px' }} /><span style={{ color: '#505d68', fontFamily: '"Karla", sans-serif', fontSize: '16px', marginLeft: 2 }}>Corporation</span>
          </Column>
        </InputContainer>
      </form>
    )
  }
}

const InputContainer = styled.div`
	display: flex;
	width: 946px;
	justify-content: space-between;
	margin: 24px;
	flex-wrap: wrap;
`;

const Column = styled.div`
	width: 465px;
	margin-bottom: 20px;
`;



// WEBPACK FOOTER //
// ./client/redesign/signup/Main/pages/Account/index.js